module.exports = __webpack_public_path__ + "static/media/SwiftShop_wk3_diagram.8710d574.svg";